import Icon from '../components/Icon.vue'

Icon.register({"bold":{"width":384,"height":512,"paths":[{"d":"M304.8 243.9C338.4 225.4 358.4 189.7 358.4 148.2 358.4 100 332.2 60.6 289.8 44 265.1 34 240.8 32 209.7 32H24C15.2 32 8 39.2 8 48V81C8 89.9 15.2 97 24 97H57.1V415.6H24C15.2 415.6 8 422.7 8 431.6V464C8 472.8 15.2 480 24 480H219.7C243.9 480 264.5 478.7 286.6 472.4 337.5 457.2 376 410.6 376 350 376 297.8 349.4 258.3 304.8 243.9zM142.2 100.8H209.7C226 100.8 237.2 102.8 247.2 107.5 263 116 272.1 134 272.1 157 272.1 192 251.8 213.8 219.1 213.8H142.2V100.8zM254.9 406.3C244.7 410.3 232.2 411.2 223.4 411.2H142.2V281.9H226.6C266.2 281.9 289.6 307.3 289.6 345 289.6 373.4 276 397.5 254.9 406.3z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/bold.js
// module id = null
// module chunks = 